import { CLIENT_ROLE_GROUPS } from "@/features/user-management/utils/roles-permissions";
import {
  ADMIN_GROUP,
  RESTRICTED_ACTIONS,
  SYSTEM_ROLES,
  BANK_GROUP,
} from "./permissionConstants";
import { useAuthStore } from "@/features/auth";

export function normalizeModulePermissions(rawPermissions = []) {
  const modules = new Set();

  for (const p of rawPermissions) {
    if (!p || typeof p !== "string") continue;
    if (p.includes(":")) continue; // ignore actions
    modules.add(p);
  }

  return modules;
}

export function normalizePermissions(rawPermissions = []) {
  const modules = new Set();
  const actions = new Set();

  for (const p of rawPermissions) {
    if (!p || typeof p !== "string") continue;

    if (p.includes(":")) {
      actions.add(p); // e.g. activity_log:view
      modules.add(p.split(":")[0]); // also consider module as enabled
    } else {
      modules.add(p); // e.g. activity_log
    }
  }

  return { modules, actions };
}

/**
 * Returns true if:
 *  - has module permission (activity_log)
 *  - OR has action permission (activity_log:view)
 * If action not provided -> checks module only (but modules already includes base from actions)
 */
export function hasPermission(perms, moduleKey, action = "view") {
  if (!perms) return false;
  //return perms.modules.has(moduleKey) || perms.actions.has(`${moduleKey}:${action}`);
  return perms.actions.has(`${moduleKey}:${action}`);
}

export function checkUserFromRole(userRole) {
  if (!userRole) return false;

  return !SYSTEM_ROLES.includes(userRole);
}

export function checkGroupFromRole(role) {
  if (!role) return false;

  return ADMIN_GROUP.includes(role)
    ? "admin_group"
    : BANK_GROUP.includes(role)
      ? "bank_group"
      : "user_group";
}

export function getRestrictedActions(
  moduleKey,
  userRole = null,
  isUserCreatedRole = false,
) {
  const { user } = useAuthStore();
  if (!userRole) {
    userRole = user?.role;
  }

  const isAdminRole = isUserCreatedRole
    ? ADMIN_GROUP.includes(userRole)
    : ADMIN_GROUP.includes(userRole) || CLIENT_ROLE_GROUPS.has(userRole);

  if (!moduleKey) return [];
  return RESTRICTED_ACTIONS[isAdminRole ? "admin" : "user"]?.[moduleKey] || [];
}
